import type { OrderItem } from '~entities/order';

import type { OrderItemCategory } from '../order-item';
import type { OrderParams, Product } from '../product';

export type ProductRequestParams = {
  merchantId: string;
  channel: 'ONLINE';
  productType: 'LOAN';
  pointOfSaleId: string;
  orderItems: OrderItem[];
  offerProductId?: string;
};

export type FindProductByParamsResponse = Product | OrderParams;

export interface ProductApi {
  getCategories: () => Promise<OrderItemCategory[]>;
  findProductByParams: (
    params: ProductRequestParams
  ) => Promise<FindProductByParamsResponse>;
}

export const PRODUCT_API_KEY = 'productApi';
